import { ShiftAction, ShiftStatus } from '../../../common/types';

export const ACTION_TRANSITION = {
	[ShiftStatus.Multi]: {
		[ShiftAction.AddOverride]: ShiftStatus.MultiQuickOverride,
	},
	[ShiftStatus.MultiQuickOverride]: {
		[ShiftAction.Cancel]: ShiftStatus.Multi,
	},
	[ShiftStatus.Single]: {
		[ShiftAction.AddOverride]: ShiftStatus.SingleQuickOverride,
	},
	[ShiftStatus.SingleQuickOverride]: {
		[ShiftAction.Cancel]: ShiftStatus.Single,
	},
} as Record<ShiftStatus, Record<ShiftAction, ShiftStatus>>;

export const SELECT_TRANSITION = {
	[ShiftStatus.Default]: ShiftStatus.Multi,
	[ShiftStatus.Multi]: ShiftStatus.Multi,
	[ShiftStatus.MultiQuickOverride]: ShiftStatus.MultiQuickOverride,
	[ShiftStatus.Single]: ShiftStatus.Multi,
	[ShiftStatus.SingleQuickOverride]: ShiftStatus.MultiQuickOverride,
} as Record<ShiftStatus, ShiftStatus>;
